import { Injectable } from '@angular/core';
import {
  SiteAdresseDetailComponent
} from "../../pages/etablissement/mon-etablissement/components/sites-adresses/components/site-adresse-detail/site-adresse-detail.component";
import {MatDialog} from "@angular/material/dialog";

@Injectable({
  providedIn: 'any',

})
export class SharedService {

  constructor(private dialog: MatDialog) { }

   openSiteAddressDetailDialog (row: any)  {
    this.dialog.open(SiteAdresseDetailComponent,{
      width : "666px",
      height : "100vh",
      position : {right : '0'},
      backdropClass : "bg-transparent",
      data : row,
      // animation: { to: "left" },
      autoFocus: false
    })
  };
}
